module.exports = __webpack_public_path__ + "resources/img/logo_partner_commerce_mansole_m.c56d0a5604b896dc8ea2481f3526743e.png";